export const VIDEO_PREFERENCES_ACTION = 'VIDEO_PREFERENCES_ACTION';
export const VIDEO_PREFERENCES_SUCCESS_ACTION =
  'VIDEO_PREFERENCES_SUCCESS_ACTION';
export const VIDEO_PREFERENCES_FAILURE_ACTION =
  'VIDEO_PREFERENCES_FAILURE_ACTION';
